import { Select } from "antd";
import React, { useMemo } from "react";
import { $t } from "~/i18n.js";

// Comprehensive list of European countries with ISO codes and emoji flags
const COUNTRIES = [
  { code: "NL", flag: "🇳🇱", name: "Nederland" }, // $t("Nederland")
  { code: "BE", flag: "🇧🇪", name: "België" }, // $t("België")
  { code: "GB", flag: "🇬🇧", name: "Engeland" }, // $t("Engeland")
  { code: "FR", flag: "🇫🇷", name: "Frankrijk" }, // $t("Frankrijk")
  { code: "AT", flag: "🇦🇹", name: "Oostenrijk" }, // $t("Oostenrijk")
  { code: "BG", flag: "🇧🇬", name: "Bulgarije" }, // $t("Bulgarije")
  { code: "HR", flag: "🇭🇷", name: "Kroatië" }, // $t("Kroatië")
  { code: "CY", flag: "🇨🇾", name: "Cyprus" }, // $t("Cyprus")
  { code: "CZ", flag: "🇨🇿", name: "Tsjechië" }, // $t("Tsjechië")
  { code: "DK", flag: "🇩🇰", name: "Denemarken" }, // $t("Denemarken")
  { code: "EE", flag: "🇪🇪", name: "Estland" }, // $t("Estland")
  { code: "FI", flag: "🇫🇮", name: "Finland" }, // $t("Finland")
  { code: "DE", flag: "🇩🇪", name: "Duitsland" }, // $t("Duitsland")
  { code: "GR", flag: "🇬🇷", name: "Griekenland" }, // $t("Griekenland")
  { code: "HU", flag: "🇭🇺", name: "Hongarije" }, // $t("Hongarije")
  { code: "IE", flag: "🇮🇪", name: "Ierland" }, // $t("Ierland")
  { code: "IT", flag: "🇮🇹", name: "Italië" }, // $t("Italië")
  { code: "LV", flag: "🇱🇻", name: "Letland" }, // $t("Letland")
  { code: "LT", flag: "🇱🇹", name: "Litouwen" }, // $t("Litouwen")
  { code: "LU", flag: "🇱🇺", name: "Luxemburg" }, // $t("Luxemburg")
  { code: "MT", flag: "🇲🇹", name: "Malta" }, // $t("Malta")
  { code: "PL", flag: "🇵🇱", name: "Polen" }, // $t("Polen")
  { code: "PT", flag: "🇵🇹", name: "Portugal" }, // $t("Portugal")
  { code: "RO", flag: "🇷🇴", name: "Roemenië" }, // $t("Roemenië")
  { code: "SK", flag: "🇸🇰", name: "Slowakije" }, // $t("Slowakije")
  { code: "SI", flag: "🇸🇮", name: "Slovenië" }, // $t("Slovenië")
  { code: "ES", flag: "🇪🇸", name: "Spanje" }, // $t("Spanje")
  { code: "SE", flag: "🇸🇪", name: "Zweden" }, // $t("Zweden")
  { code: "CH", flag: "🇨🇭", name: "Zwitserland" }, // $t("Zwitserland")
  { code: "NO", flag: "🇳🇴", name: "Noorwegen" }, // $t("Noorwegen")
];

export const CountryLabel = ({ code }) => {
  const country = COUNTRIES.find((c) => c.code === code);
  if (!country) return null;
  return (
    <span>
      {country.flag} {$t(country.name)}
    </span>
  );
}

export const CountryCodeSelect = ({ clubCountry, ...props }) => {
  const sortedCountries = useMemo(() => {
    if (!clubCountry) return COUNTRIES;

    // Find club's country and move it to the top
    const clubCountryItem = COUNTRIES.find((c) => c.code === clubCountry);
    const otherCountries = COUNTRIES.filter((c) => c.code !== clubCountry);

    return clubCountryItem ? [clubCountryItem, ...otherCountries] : COUNTRIES;
  }, [clubCountry]);

  const options = sortedCountries.map((country) => ({
    value: country.code,
    label: `${country.flag} ${$t(country.name)}`,
  }));

  return (
    <Select
      {...props}
      showSearch
      optionFilterProp="label"
      options={options}
      placeholder={$t("Selecteer een land")}
    />
  );
};
